import { Formik, FormikProps } from "formik";
import React, { FC, memo } from "react";

import { FormikForm } from "@/formikComponents";
import {
  AboutMeFormComponent,
  IAboutMeFormSectionValues,
  validationAboutMeFormSchema as validationSchema,
} from "@/views/ConsultantProfiles/Detail/AboutMeSection/AboutMeForm";
import {
  IProfileFormikProps,
  profilePartialUpdaterBuilder,
} from "@/views/ConsultantProfiles/Detail/profilePartialUpdaterBuilder";

import { Buttons } from "./Buttons";

const Form: FC<IProfileFormikProps<IAboutMeFormSectionValues>> = memo(
  ({ initialValues, validationSchema: vs, onSubmit, onCancel }) => (
    <Formik initialValues={initialValues} validationSchema={vs} onSubmit={onSubmit}>
      {(form: FormikProps<IAboutMeFormSectionValues>) => (
        <>
          <FormikForm>
            <AboutMeFormComponent form={form} />
            <Buttons form={form} onClose={onCancel} />
          </FormikForm>
        </>
      )}
    </Formik>
  ),
);

export const AboutMeFormik = profilePartialUpdaterBuilder(Form, {
  validationSchema,
  messengerContext: "",
});
